import React from 'react';
import { ReactivationSettings as ReactivationSettingsComponent } from '@/components/settings/ReactivationSettings';

const ReactivationSettings = () => {
  return (
    <div className="bg-slate-50 p-6 md:p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Configurações de Reativação</h1>
          <p className="text-slate-600">
            Gerencie a cadência automática de reativação de leads que foram marcados como LOST
          </p>
        </div>

        <ReactivationSettingsComponent />
      </div>
    </div>
  );
};

export default ReactivationSettings;
